module.exports = __webpack_public_path__ + "static/authorized-notice-348fbcfaa981ff4e88d2f22f6a82ebd0.png";